export default __webpack_public_path__ + "logo-google-play-12ee505ddee4f52f4433c01efc2ddb9e.svg";